/* eslint-disable no-nested-ternary */
import axios from 'axios'; //eslint-disable-line
import { action, computed, observable, flow, toJS } from 'mobx'; //eslint-disable-line
import _reduce from 'lodash/reduce'; //eslint-disable-line
import _flatten from 'lodash/flatten'; //eslint-disable-line
import _uniqueBy from 'lodash/uniqBy'; //eslint-disable-line
import _isEqual from 'lodash/isEqual';
import _differenceWith from 'lodash/differenceWith';
import { createContext } from 'react';

import goTrackerConfig from 'goTrackerConfig';
import * as CONSTS from '../utils/constants';
import { viewStore } from './viewStore';
import utils from '../utils';

class LocationStore {
  @observable corridors = [];
  @observable corridor = null;
  @observable corridorCode = '';
  @observable stationCode = '';

  /**trips by corridor and station */
  @observable stationTrips = [];
  /**trips from union to station */
  @observable unionDepartureTrips = [];
  @observable trip = null;
  @observable station = null;
  @observable busStations = [];
  @observable messages = null;
  @observable stations = [];
  @observable service = [];
  @observable allTrips = [];
  @observable isLoading = false;
  @observable scrollingMessages = [];

  pinsMapping = [];

  @observable busTripNumber = null;
  @observable busTripDetail = null;
  @observable overallMessages = [];
  @observable gotMessage = false;
  @observable isTripTakeover = false;

  @observable isUnionDepartureLoaded = false;
  @observable isBusTripLoaded = false;
  @observable isTripLoaded = false;

  stationsWithMultipleCorridor = ['DA', 'SCTH'];

  @action
  resetStore = () => {
    this.corridor = null;
    this.stationTrips.clear();
    this.resetDepartureData();
    this.trip = null;
    this.station = null;
    this.service.clear();
    this.allTrips.clear();
    this.isLoading = false;
  };

  @action
  resetDepartureData = () => {
    this.unionDepartureTrips.clear();
    this.messages = null;

    console.log('Departure data cleared');
  };

  @action
  resetTripDetail = () => {
    this.trip = null;
    this.busTripDetail = null;
    this.busTripNumber = null;
  };

  @action
  setCorridor = (corridorCode, corridorName = 'All Lines') => {
    console.log(`SetCorridor: ${corridorCode}`);
    if (corridorCode < 0) {
      this.corridor = { id: corridorCode, name: corridorName, code: corridorCode, stops: [] };
      this.corridorCode = corridorCode;
      this.station = this.sortedDefaultStop;
    } else {
      // Store corridor code in case corridor is not yet loaded
      this.corridorCode = corridorCode;

      this.corridor = this.corridorStations.find(c => c.code === corridorCode);
    }

    // If corridor cannot be found, reset the station and don't look for a default station
    if (!this.corridor) {
      this.station = null;
    }

    // If station is empty or doesn't belong to this corridor, set the default station.
    if (!this.station || this.corridor.stops.findIndex(s => s.code === this.station.code) === -1) {
      this.station = this.stopsDictionary[this.defaultStationCode];
    }

    if (corridorCode === CONSTS.BUS_TERMINAL_CODE) {
      this.corridor = { id: corridorCode, name: 'Bus Terminals', code: corridorCode, stops: [] };
      const busStationsToHide = goTrackerConfig.busTerminalToHide;
      if (busStationsToHide?.length > 0) {
        this.station = this.busStations.filter(x => !busStationsToHide.includes(x.code))[0];
      } else {
        this.station = this.busStations[0];
      }
      if (this.station !== undefined && this.station.description !== undefined) {
        this.station.name = this.station.description;
      }
    }

    viewStore.setLastCorridorAndStation();
  };

  @action
  setStation = stationCode => {
    this.stationCode = stationCode;
    let _station = this.stopsDictionary[stationCode] ?? this.stopsDictionaryTimingPoint[this.station?.code];
    if (_station === undefined) {
      _station = this.busStations.filter(x => x.code === stationCode)[0];
      if (_station !== undefined) {
        _station.name = _station.description;
        _station.atlsId = _station.code;
      }
    }
    this.station = _station;
    console.log(`setStation: ${stationCode}`);

    viewStore.setLastCorridorAndStation();
  };

  @action
  setBusStation = busStationCode => {
    let _station = this.stopsDictionaryTimingPoint[busStationCode];
    if (_station === undefined) {
      _station = this.busStations.filter(x => x.code === busStationCode)[0];
      if (_station !== undefined) {
        _station.name = _station.description;
        _station.atlsId = _station.code;
      }
    }
    this.station = _station;
    console.log(`setStation: ${busStationCode}`);

    viewStore.setLastCorridorAndStation();
  };

  @action
  loadData = flow(function*() {
    try {
      console.log('Loading lines and stations...');

      yield this.loadCorridors();
      this.pinsMapping = utils.mapStationNameToPINS(goTrackerConfig.pinsNameMapping);
      this.loadTripsByCorridorAndStation();
      // this.loadAllTrips();
      yield this.loadAllBusTerminals();
    } catch (err) {
      console.log(err);
    }
  });

  @computed
  get isSelectionValid() {
    if (!this.station || !this.corridor) return false;

    return true;
  }

  @action
  loadTrip = flow(function*(tripNum) {
    let tripNumber = tripNum;
    if (!tripNum) {
      tripNumber = this.trip ? this.trip.tripNumber : null;
    }

    if (!tripNumber) {
      return;
    }

    try {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };
      this.isTripLoaded = false;
      const url = `${goTrackerConfig.prefix}${goTrackerConfig.services.goTracker}/web/Schedule/Today/Trip/${tripNumber}`;

      const response = yield axios(url, options);

      if (response.data && Array.isArray(response.data.commitmentTrip)) {
        this.trip = response.data.commitmentTrip[0];
      }
    } catch (err) {
      console.log(err);
    } finally {
      this.isTripLoaded = true;
    }
  });

  @action
  loadBusTrip = flow(function*(tripNum) {
    let tripNumber = tripNum;
    if (!tripNum) {
      tripNumber = this.busTripDetails ? this.busTripDetails.tripNumber : null;
    }

    if (!tripNumber) {
      return;
    }
    try {
      this.isBusTripLoaded = false;
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };
      const url = `${goTrackerConfig.prefix}${goTrackerConfig.services.goTracker}/web/Messages/Signage/Bus/TripDetail/${tripNumber}`;

      const response = yield axios(url, options);

      if (response.data && Array.isArray(response.data.stops)) {
        this.busTripDetail = response.data;
        if (response.data.tripMessages !== undefined && response.data.tripMessages.length > 0) {
          const msgs = response.data.tripMessages; //.map((b) => {return b.message !== null ? b.message : b.frenchMessage;});
          if (msgs.length < this.scrollingMessages.length) {
            this.scrollingMessages = msgs;
          } else {
            this.addScrollingMessages(msgs);
            this.gotMessage = true; // check if override message
          }
        } else {
          this.scrollingMessages = [];
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      this.isBusTripLoaded = true;
    }
  });

  @action
  updateFromSignalr = flow(function*() {
    try {
      // eslint-disable-next-line no-unused-vars
      const response = yield [this.loadTripsByCorridorAndStation(), this.loadTrip()];
      console.log('Refreshed from SignalR Update');
    } catch (err) {
      console.log(err);
    }
  });

  @action
  loadCorridors = flow(function*() {
    try {
      this.isLoading = true;

      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };
      const url = `${goTrackerConfig.prefix}${goTrackerConfig.services.goTracker}/web/Info/TripPatterns/Train`;

      const response = yield axios(url, options);

      if (response.data && Array.isArray(response.data)) {
        this.corridors = response.data;

        console.log('Lines and stations loaded');
      }
    } catch (err) {
      console.log(err);
    } finally {
      this.isLoading = false;
    }
  });

  @action
  loadUnionDepartures = flow(function*() {
    if (!this.station) return;

    const stationNameInPINS = this.pinsMapping.find(p => p.stationCode === this.station.code);
    const stationName = stationNameInPINS ? stationNameInPINS.stationName : this.station.name;

    console.log(`Loading Union Departures for station: ${stationName}...`);

    try {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };
      const url = `${goTrackerConfig.prefix}${goTrackerConfig.services.goTracker}/web/Messages/DeparturesWithCoachCount/${stationName}`;
      const response = yield axios(url, options);
      this.isUnionDepartureLoaded = false;

      if (response.data && Array.isArray(response.data.trips)) {
        this.unionDepartureTrips = response.data.trips.filter(trip => trip.serviceType === CONSTS.SERVICE_TRAIN);

        console.log('Union Departures Loaded');
      }
    } catch (err) {
      console.log(err);
    } finally {
      this.isUnionDepartureLoaded = true;
    }
  });

  @action
  loadAllTrips = flow(function*() {
    try {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };
      const url = `${goTrackerConfig.prefix}${goTrackerConfig.services.goTracker}/web/Schedule/Today/All`;

      const response = yield axios(url, options);

      if (response.data && Array.isArray(response.data.commitmentTrip)) {
        this.allTrips = response.data.commitmentTrip;
      }
    } catch (err) {
      console.log(err);
    }
  });

  @action
  loadTripsByCorridorAndStation = flow(function*(corridorCode, stationCode) {
    const _corridorCode = !utils.isNullOrEmpty(corridorCode) ? corridorCode : this.corridor ? this.corridor.code : '';
    const _stationCode = !utils.isNullOrEmpty(stationCode) ? stationCode : this.station ? this.station.code : '';

    if (utils.isNullOrEmpty(_stationCode)) return;

    console.log(`Loading Station Departures for corridor: ${_corridorCode}, station: ${_stationCode}...`);

    try {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };
      const url = `${goTrackerConfig.prefix}${goTrackerConfig.services.goTracker}/web/Messages/Signage/Rail/${_corridorCode}/${_stationCode}`;
      const response = yield axios(url, options);

      if (response.data) {
        this.messages = response.data;
        this.updateScrollingMessage(this.messages.messages);
        console.log('Station Departures Loaded ');
      }
    } catch (err) {
      console.log(err);
    }
  });

  @action
  loadMessagesForTimingPoint = flow(function*(timingPoint) {
    if (timingPoint === undefined) return;

    if (utils.isNullOrEmpty(timingPoint)) return;
    console.log(`Loading Bus Messages: ${timingPoint}...`);
    try {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };
      const url = `${goTrackerConfig.prefix}${goTrackerConfig.services.goTracker}/web/Messages/Signage/Bus/Messages/${timingPoint}`;
      const response = yield axios(url, options);

      if (response.data) {
        const msgs = response.data
          .filter(x => x.body !== undefined)
          .map(b => {
            const result = b.body;
            result.isTakeover = b.settings.setting.some(x => x.name !== undefined);
            result.setting = b.settings?.setting;
            return result;
          });
        if (msgs.length < this.scrollingMessages.length) {
          this.scrollingMessages = msgs;
        } else {
          this.addScrollingMessages(msgs);
          const isOverride = msgs.some(x => x.isTakeover);
          this.gotMessage = false;
          if (isOverride) {
            this.gotMessage = true;
          }
        }
      } else {
        this.scrollingMessages = [];
      }
    } catch (err) {
      console.log(err);
    }
  });

  @action doTakeOverCheck(response) {
    response.data.forEach((d, i) => {
      const isOverride = d.settings.setting.some(x => x.name === 'IsTakeover' && x.value === 'True');
      if (isOverride) {
        this.gotMessage = true;
        response.data[i].isTakeover = true;
      }
    });
  }

  @action
  loadOverrideMessages = flow(function*(timingPoint) {
    if (timingPoint === undefined) return;

    if (utils.isNullOrEmpty(timingPoint)) return;
    console.log(`Loading Bus Messages: ${timingPoint}...`);
    try {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };
      const url = `${goTrackerConfig.prefix}${goTrackerConfig.services.goTracker}/web/Messages/Services/Bus/Messages/${timingPoint}`;
      const response = yield axios(url, options);

      if (response.data) {
        const msgs = response.data
          .filter(x => x.body !== undefined)
          .map(b => {
            return b.body;
          });
        if (msgs.length < this.overallMessages.length) {
          this.overallMessages = msgs;
          this.gotMessage = true;
        }
      } else {
        this.overallMessages = [];
      }
    } catch (err) {
      console.log(err);
    }
  });

  @action
  loadBusTripByTimingPoint = flow(function*(timingPoint) {
    if (timingPoint === undefined) return;

    if (utils.isNullOrEmpty(timingPoint)) return;
    console.log(`Loading Bus Departures: station: ${timingPoint}...`);
    try {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };

      const url = `${goTrackerConfig.prefix}${goTrackerConfig.services.goTracker}/web/Messages/Signage/Bus/${timingPoint}`;
      const response = yield axios(url, options);

      if (response.data) {
        this.messages = response.data;
        this.loadMessagesForTimingPoint(timingPoint);
        console.log('Station Departures Loaded ');
      }
    } catch (err) {
      console.log(err);
    }
  });

  @action
  loadUnionBusDepartures = flow(function*(timingPoint) {
    if (timingPoint === undefined) return;

    if (utils.isNullOrEmpty(timingPoint)) return;
    console.log(`Loading Bus Departures: station: ${timingPoint}...`);
    try {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };
      const url = `${goTrackerConfig.prefix}${goTrackerConfig.services.goTracker}/web/Messages/Departures/USBT/${timingPoint}`;
      const response = yield axios(url, options);

      if (response.data) {
        this.messages = response.data;
        this.loadMessagesForTimingPoint(timingPoint);
        console.log('Union Bus Departures Loaded ');
      }
    } catch (err) {
      console.log(err);
    }
  });

  @action
  loadUnionBusTrainDepartures = flow(function*(stationCode, timingPoint) {
    if (timingPoint === undefined) return;

    if (utils.isNullOrEmpty(timingPoint)) return;
    console.log(`Loading Union Departures: ${stationCode} ${timingPoint}...`);

    const stationNameInPINS = this.pinsMapping.find(p => p.stationCode === this.station.code);
    const stationName = stationNameInPINS ? stationNameInPINS.stationName : this.station.name;
    try {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };
      const url = `${goTrackerConfig.prefix}${goTrackerConfig.services.goTracker}/web/Messages/Departures/TrainBus/${stationName}/${timingPoint}`;
      const response = yield axios(url, options);
      this.isUnionDepartureLoaded = false;

      if (response.data) {
        this.unionDepartureTrips = response.data.trips;
        // this.loadMessagesForTimingPoint(timingPoint);
        console.log('Union Departures Loaded ');
      }
    } catch (err) {
      console.log(err);
    } finally {
      this.isUnionDepartureLoaded = true;
    }
  });

  loadStationDepartureMsg = (corridorCode, stationID) => {
    const url = `${goTrackerConfig.prefix}${goTrackerConfig.services.goTracker}/web/Messages/Signage/Rail/Messages/${corridorCode}/${stationID}`;

    return axios(url);
  };

  loadUnionDepartureMsg = stationName => {
    const url = `${goTrackerConfig.prefix}${goTrackerConfig.services.goTracker}/web/Messages/Departures/${stationName}`;

    return axios(url);
  };

  loadTripDetail = tripNumber => {
    const url = `${goTrackerConfig.prefix}${goTrackerConfig.services.goTracker}/web/Schedule/Today/Trip/${tripNumber}`;

    return axios(url);
  };

  @action updateBusMessage = timingPoint => {
    if (!Array.isArray(timingPoint)) return;
    this.loadMessagesForTimingPoint(timingPoint);
  };

  @action updateScrollingMessage = messages => {
    if (!Array.isArray(messages)) return;

    if (messages.length < this.scrollingMessages.length) {
      this.scrollingMessages = messages;
    } else {
      this.addScrollingMessages(messages);
    }
  };

  @action
  loadAllBusTerminals = flow(function*() {
    try {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };
      const url = `${goTrackerConfig.prefix}${goTrackerConfig.services.goTracker}/web/Info/Places/BusTerminal`;

      const response = yield axios(url, options);

      if (response.data && Array.isArray(response.data.places)) {
        this.busStations = response.data.places;
      }
    } catch (err) {
      console.log(err);
    } finally {
      this.isLoading = false;
    }
  });

  @action
  addScrollingMessages = messages => {
    if (!messages || messages.length < 1) return;

    //Deep compare and retrieve the difference
    const newMessages = _differenceWith(messages, this.scrollingMessages, _isEqual);

    //We don't want mutations
    if (newMessages.length > 0) {
      this.scrollingMessages.push(...newMessages);
    }
  };

  getStationIdFromCode = code => {
    if (utils.isNullOrEmpty(code)) return '';

    const station = this.allStops.find(s => s.code === code);

    return station !== undefined ? station.atlsId : '';
  };

  @computed
  get defaultStationCode() {
    if (!this.corridor || !this.corridor.stops || this.corridor.stops.length < 1) return '';

    const stops = this.corridor.stops.filter(stop => stop.code !== CONSTS.STATION_CODE_UNION);

    return stops.length > 0 ? stops[0].code : '';
  }

  @computed
  get allTripsByStation() {
    if (this.allTrips.length < 1 || utils.isNullOrEmpty(this.station)) return '';

    return this.allTrips.filter(trip => trip.tripName.includes(this.station.name)).sort((a, b) => a.tripName.localeCompare(b.tripName));
  }

  @computed
  get allStops() {
    const stops = _flatten(this.corridorStations.map(l => l.stops));

    return _uniqueBy(stops, s => s.atlsId);
  }

  @computed
  get stopsDictionaryTimingPoint() {
    const stops = _flatten(this.corridorStations.map(l => l.stops));

    return _reduce(
      stops,
      (result, stop) => {
        result[stop.timingPoint] = stop;
        return result;
      },
      {}
    );
  }

  @computed
  get stopsDictionary() {
    const stops = _flatten(this.corridorStations.map(l => l.stops));

    return _reduce(
      stops,
      (result, stop) => {
        result[stop.code] = stop;
        return result;
      },
      {}
    );
  }

  @computed
  get stationsByCorridor() {
    if (this.corridor) {
      return this.allStops
        .filter(stop => stop.atlsId !== CONSTS.STATION_ID_UNION && stop.corridorId === this.corridor.corridorId)
        .map(stop => {
          return { value: stop.atlsId, label: stop.name };
        });
    }

    return this.allStops
      .filter(stop => stop.atlsId !== CONSTS.STATION_ID_UNION)
      .map(stop => {
        return { value: stop.atlsId, label: stop.name };
      })
      .sort((a, b) => a.label.localeCompare(b.label));
  }

  @computed
  get corridorStations() {
    return this.corridors.map(l => {
      const newStops = l.stops
        .filter(stop => stop.code !== 'UN')
        .map(stop => ({ ...stop, corridorCode: l.code }))
        .sort((a, b) => a.stopOrder - b.stopOrder);

      return {
        code: l.code,
        corridorId: l.corridorId,
        isBus: l.isBus,
        name: l.name,
        stops: newStops,
      };
    });
  }

  @action
  setScreenTakover = isTakeOver => {
    this.isTripTakeover = isTakeOver;
  };

  @action
  setGotMessage = gotMessage => {
    this.gotMessage = gotMessage;
  };

  @action
  updateDataMessagesSignageRail = (data) => {
    this.messages = data;
  };

  @computed
  get unionDepartureTripMessage() {
    if (!this.trip || this.unionDepartureTrips.length === 0) return null;

    return this.unionDepartureTrips.find(trip => trip.number === this.trip.tripNumber);
  }

  @computed
  get hasBusDepartures() {
    return this.messages && Array.isArray(this.messages.commitmentTrips) && !this.gotMessage;
  }

  @computed
  get hasUsbtDepartures() {
    return this.messages && Array.isArray(this.messages.trips) && !this.gotMessage;
  }

  @computed
  get multipleCorridorsIndex() {
    if (!this.stationCode) return false;

    return this.stationsWithMultipleCorridor.findIndex(station => station === this.stationCode);
  }

  @computed
  get sortedDefaultStop() {
    if (!Array.isArray(this.allStops)) return [];

    return this.allStops.sort((a, b) => a.name.localeCompare(b.name)).find(s => s.atlsId !== CONSTS.STATION_ID_UNION);
  }
}

const locationStore = new LocationStore();
window.toJS = toJS;
export default createContext(locationStore);

export { locationStore };
